/** Hlavné odkazy v navigácii a pätičke (musia zostať v súlade). */
export const primaryNavItems = [
  { name: 'Kniha', path: '/kniha', id: 'kniha' },
  { name: 'Spolupráca', path: '/spolupraca', id: 'spolupraca' },
  { name: 'Pre firmy', path: '/firmy', id: 'b2b' },
  { name: 'Kariéra', path: '/kariera', id: 'kariera' },
  { name: 'Príbeh', path: '/o-mne', id: 'pribeh' },
  { name: 'Blog', path: '/blog', id: 'blog' },
];
